import { render, staticRenderFns } from "./contragents-item.vue?vue&type=template&id=6c8d4e03"
import script from "./contragents-item.vue?vue&type=script&lang=js"
export * from "./contragents-item.vue?vue&type=script&lang=js"
import style0 from "./contragents-item.vue?vue&type=style&index=0&id=6c8d4e03&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports